// Firebase Authentication Service
import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signInWithPopup,
    GoogleAuthProvider,
    signOut,
    onAuthStateChanged
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase.js'; // Keep db for getDoc in Google Sign In
import { createUserProfile } from './firestore.js';

const googleProvider = new GoogleAuthProvider();

// Sign up with email/password
export const signUpWithEmail = async (email, password, displayName, referrerId = null) => {
    try {
        const result = await createUserWithEmailAndPassword(auth, email, password);

        // Create user profile via Firestore Service
        await createUserProfile(result.user.uid, {
            uid: result.user.uid,
            name: displayName,
            email: email,
            avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${displayName}`,
            bio: '',
            socialLinks: {},
            stats: {
                sparksCreated: 0,
                likesReceived: 0,
                challengesCompleted: 0,
                museUsage: 0
            },
            hasSeenTutorial: false
        }, referrerId);

        return result.user;
    } catch (error) {
        throw error;
    }
};

// Sign in with email/password
export const signInWithEmail = async (email, password) => {
    try {
        const result = await signInWithEmailAndPassword(auth, email, password);
        return result.user;
    } catch (error) {
        throw error;
    }
};

// Sign in with Google
export const signInWithGoogle = async (referrerId = null) => {
    try {
        const result = await signInWithPopup(auth, googleProvider);

        // Check if user exists in Firestore
        const userDoc = await getDoc(doc(db, 'users', result.user.uid));

        if (!userDoc.exists()) {
            // Create new user profile
            await createUserProfile(result.user.uid, {
                uid: result.user.uid,
                name: result.user.displayName,
                email: result.user.email,
                avatar: result.user.photoURL || `https://api.dicebear.com/7.x/avataaars/svg?seed=${result.user.displayName}`,
                bio: '',
                socialLinks: {},
                stats: {
                    sparksCreated: 0,
                    likesReceived: 0,
                    challengesCompleted: 0,
                    museUsage: 0
                },
                hasSeenTutorial: false
            }, referrerId);
        }

        return result.user;
    } catch (error) {
        throw error;
    }
};

// Sign out
export const logOut = async () => {
    try {
        await signOut(auth);
    } catch (error) {
        throw error;
    }
};

// Listen to auth state changes
export const onAuthChange = (callback) => {
    return onAuthStateChanged(auth, callback);
};

// Get current user from Firestore
export const getCurrentUser = async (uid) => {
    try {
        const userDoc = await getDoc(doc(db, 'users', uid));
        if (userDoc.exists()) {
            return userDoc.data();
        }
        return null;
    } catch (error) {
        throw error;
    }
};
